import { render, staticRenderFns } from "./edit-topic.vue?vue&type=template&id=5abd57b6"
import script from "./edit-topic.ts?vue&type=script&lang=js&external"
export * from "./edit-topic.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports